module.exports = __webpack_public_path__ + "static/media/collection.5a1d20d2.svg";